import {
  Component,
  OnInit,
  Inject,
} from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { TranslateService } from '../../../../translate';

import { InventoryComponent } from '../../../../modules/inventory/pages/inventory.component';
import { NotificationsService } from 'angular2-notifications';
import { LoadingService } from '../../../../shared/services/loading.service';
import { SystemComponentViewModel } from '../../../../modules/inventory/inventory-models';
import {
  AvailableActionViewModel,
  AvailableActionsForComponentInInventory,
  ActionInInventoryViewModel,
  ReplacementCompartmentViewModel,
  GeneralActionViewModel,
  ComponentOnSystemViewModel
} from '../../action-models';
import { ActionService } from '../../action.service.service';
import {
  ActionType,
  Customer,
  Compart,
  CompartType,
  Make
} from '../../../../entities';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../../modules/rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { FormControl } from '@angular/forms';
import moment from 'moment';
import { AppService } from '../../../../app.service';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

// import * as _moment from 'moment';
@Component({
  selector: 'app-action-popup',
  templateUrl: './action-popup.component.html',
  styleUrls: ['./action-popup.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 0 }),
        animate('0ms', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class ActionPopupComponent implements OnInit {
  component: SystemComponentViewModel;
  action = new GeneralActionViewModel();
  date = new FormControl(moment());
  LabourCostOptions = [{ Id: 0, Name: 'Dollar' }, { Id: 1, Name: 'Hourly' }];

  labourCostLableTitle = 'Labour Cost';
  cutomerHourlyRate = 0;
  availableActions: AvailableActionViewModel[] = [];
  customer: Customer;
  modelId: number;
  make:string;
  makeId:number;

  needToInputHourlyRate: boolean;

  userLanguage = 'english';
  Makes: Make[] = [];
  availableCompartments: ReplacementCompartmentViewModel[] = [];
  isloadingReplacementCompart: boolean;
  isReplaceWithNewAction;

  saving: boolean;

  allRollers: ComponentOnSystemViewModel[];

  allComponents: ComponentOnSystemViewModel[];
  systemId: number;

  actionHelper: AvailableActionsForComponentInInventory = new AvailableActionsForComponentInInventory();
  constructor(
    private _translate: TranslateService,
    public dialogRef: MatDialogRef<InventoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notification: NotificationsService,
    private loadingService: LoadingService,
    private _dialog: MatDialog,
    private _actionService: ActionService,
    private _appService: AppService,

  ) {}

  ngOnInit() {
    this.loadingService.startLoading();
    if (this.data.component != null) {
      console.log(this.data.component);
      this.component = this.data.component;
      this.customer = this.data.customer;
      this.modelId = this.data.modelId;
      this.systemId = this.data.systemId;
      this.make = this.data.make;
      this.makeId = this.data.makeId;
      this.action.NewSMU=this.component.CMU;
      this.availableActions = this.actionHelper.GetActions(
        this.component.CompartType
      );
    }

    this._actionService.getComponentsOnThisSystem(this.systemId).subscribe( r => {
      console.log(r);
      this.allComponents = r;
    });

    this._actionService.GetComponentReplacementBrends().subscribe(result => {
      this.Makes = result;
      if ( this.Makes.filter( a => a.Title === this.make ).length === 0) {
        var m =new Make;
        m.Id=this.makeId;
        m.Title=this.make;
        this.Makes.unshift(m);
      }
      this.loadingService.finishedLoading();
    },
      error => { console.error(error); }, );
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  currentTotalCost(): number {

    if(this.showCost)
      return this.action.Cost;
    if (this.action.LabourCostOption === 0) {
      return (
        this.action.PartCost + this.action.LabourCost + this.action.MiscCost
      );
    }
    return (
      this.action.PartCost +
      this.cutomerHourlyRate * this.action.LabourCost +
      this.action.MiscCost
    );
  }

  labourCostOptionChanged(event) {
    if (this.action.LabourCostOption === 0) {
      this.labourCostLableTitle = 'Labour Cost';
    } else {
      this.labourCostLableTitle = 'Hours';
      this._actionService
        .getCustomerHourlyRate(this.customer.Id)
        .subscribe(r => {
          this.cutomerHourlyRate = r;
          this.action.HourlyRate = r;
          if (this.cutomerHourlyRate === 0 || this.cutomerHourlyRate < 0) {
            this.needToInputHourlyRate = true;
          }
        });
    }
  }


  swapRollerEvent(selectedRoller: ComponentOnSystemViewModel) {
    this.action.NewEqUnitId = selectedRoller.GeneralEqunitId;
  }

Buttondisabled:boolean;
showCost: boolean = false;
  actionChanged(event) {
    const action = this.availableActions.find(
      a => a.ActionTypeId === event.value
    );
    const checkString = action.ActionTypeName.split(' ');
    if (checkString[0] === 'Replace') {
      this.loadingService.startLoading();
      this.isloadingReplacementCompart = true;
      this.isReplaceWithNewAction = true;
      this.showCost = true;
      this._actionService
        .getReplacementComponentOptions(this.component.EqunitId)
        .subscribe(r => {
          this.loadingService.finishedLoading();
          this.isloadingReplacementCompart = false;
          console.log(r);
          this.availableCompartments = r;
        });
    } else {
      this.isReplaceWithNewAction = false;
      this.showCost = false;
    }

    if ( +action.ActionTypeId === 10602 || +action.ActionTypeId === 17 || +action.ActionTypeId === 10702 ) {
      this.allRollers = this.allComponents.filter(c => c.CompartTypeId === this.component.CompartType);
      this.showCost = false;
    }

  }

  replacementCompartChanged(event) {
    // get budget life
    console.log(event);
    this.loadingService.startLoading();
    // this.action.ReplaceComponentCompartId = this.component.
    this._actionService
      .getComponentBudgetLife(this.component.EqunitId)
      .subscribe((l:any) => {
        this.loadingService.finishedLoading();
        this.action.BudgetLife = l;
      });
  }

  RecordAction() {
    console.log(this.action);
    this.action.ActionEqUnitId = this.component.EqunitId;
    if(this.isReplaceWithNewAction && (!this.action.MakeId || this.action.MakeId <= 0)) {
      this.notification.warn('Please select a component Make to proceed.');
      return;
    }
    if(this.action.ActionTypeId>0){
    this.Buttondisabled=true;
    this._actionService.recordNewInventoryAction(this.action).subscribe(a => {
      console.log(a);
      if (a.m_Item1) {
        this.notification.success('Successfully Recorded Inventory Action');
        this.dialogRef.close(true);
      } else {
        this.notification.error('Failed to Recorded Inventory Action  ' + a.m_Item2);
        console.log(a.m_Item2);
      }
      this.Buttondisabled=false;
    });
  }else{
    this.notification.warn('Select Action type.');
  }
  }
}
